import { SummaryMode } from './types'
import type { TimeSeriesDataPoint } from './types'

/**
 * Summarises a time series for the summary panel and insight messaging.
 *
 * - `latest`: the period total for count metrics (SummaryMode.Total), otherwise
 *   the last data point's value (default, for cumulative metrics like Followers).
 * - `change`: first→last delta for level metrics; null for Total metrics, where
 *   a within-period delta isn't meaningful.
 *
 * Pure and dependency-light (types only) so it can be imported by the chart and
 * the insight logic without pulling in the chart component's dependencies.
 */
export function getTimeSeriesSummary(
  data: TimeSeriesDataPoint[],
  mode: SummaryMode = SummaryMode.Latest,
): {
  latest: number | null
  change: number | null
} {
  const validPoints = data.filter(
    (p): p is TimeSeriesDataPoint & { value: number } => p.value != null,
  )

  if (validPoints.length === 0) return { latest: null, change: null }

  if (mode === SummaryMode.Total) {
    const total = validPoints.reduce((sum, p) => sum + p.value, 0)
    return { latest: total, change: null }
  }

  const latest = validPoints[validPoints.length - 1].value
  const first = validPoints[0].value
  const change = latest - first

  return { latest, change }
}
